import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Status } from "../../common/constants";
import api from '../../api';
import { RootState } from "../../store";
import { getPublicApiApprovalStatusUrl } from "../../config";
import { getCookie } from "../../common/utils";

const FETCH_APPROVAL_STATUS = "getPublicApiApprovalStatus";

interface IGetPublicApiApprovalStatusResponse {
  isSuperAdminApproved: boolean;
}

interface IGetPublicApiApprovalStatusState {
  status: string;
  error: string | null;
  isSuperAdminApproved: boolean | null;
}

const initialState: IGetPublicApiApprovalStatusState = {
  status: Status.IDLE,
  error: null,
  isSuperAdminApproved: null,
};

export const getPublicApiApprovalStatus = createAsyncThunk(
  FETCH_APPROVAL_STATUS,
  async (_, { rejectWithValue }) => {
    try {
      const orgId = getCookie('organizationId');
      const response = await api.get<IGetPublicApiApprovalStatusResponse>(
        `${getPublicApiApprovalStatusUrl}?orgId=${orgId}`
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

const getPublicApiApprovalStatusSlice = createSlice({
  name: FETCH_APPROVAL_STATUS,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPublicApiApprovalStatus.pending, (state) => {
        state.status = Status.PENDING;
        state.error = null;
        state.isSuperAdminApproved = null;
      })
      .addCase(getPublicApiApprovalStatus.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.isSuperAdminApproved = (action.payload as any).message.isSuperAdminApproved;
      })
      .addCase(getPublicApiApprovalStatus.rejected, (state, action) => {
        const errorPayload = action.payload as { response?: { data?: { message?: string } } };
        state.status = Status.FAILED;
        state.error = errorPayload?.response?.data?.message || action.error.message || 'Unknown error';
      });
  },
});

// selector for component to use
export const selector = (state: RootState) => state.getPublicApiApprovalStatus;

export default getPublicApiApprovalStatusSlice.reducer;
